import { render, staticRenderFns } from "./PayPalCheckout.vue?vue&type=template&id=2ac60474"
import script from "./PayPalCheckout.vue?vue&type=script&lang=js"
export * from "./PayPalCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports